/**
 * @name Notification
 * @description Componente notificación
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

import { Icons, MUI, Typography } from '@styles';

const Notification = (props) => {
  const { notification } = props;
  return (
    <Styled.NotificationWrapper>
      <Styled.NotificationContent onClick={() => props.onReadNotification(notification)}>
        <Styled.BoxImage>
          <Styled.NotificationAppIcon
            src={notification.Logo}
            alt={notification.Aplicacion}
            appId={notification.IdAplicacion}
          />
        </Styled.BoxImage>
        <Styled.NotificationBody>
          <Styled.AppText>
            {notification.Aplicacion}
          </Styled.AppText>
          <Styled.NotificationMessage>
            <Trans>{notification.MensajeNotificacion}</Trans>
          </Styled.NotificationMessage>
          <Styled.BoxTime>
            <Icons.Time />
            <Styled.TimeText>
              {notification.Tiempo}
            </Styled.TimeText>
          </Styled.BoxTime>
        </Styled.NotificationBody>
      </Styled.NotificationContent>
      <Styled.BoxClose color="default" onClick={() => props.onDeleteNotification(notification.Id)}>
        <Icons.Close />
      </Styled.BoxClose>
    </Styled.NotificationWrapper>
  );
};

Notification.propTypes = {
  // El objecto con la información de la notificación.
  notification: PropTypes.object.isRequired,
  // Función para leer y redireccionar la notificación.
  onReadNotification: PropTypes.func.isRequired,
  // Función para eliminar la notificación.
  onDeleteNotification: PropTypes.func.isRequired
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.NotificationWrapper = styled.div`
  display: flex;
  width: 100%;
`;

Styled.NotificationContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

Styled.NotificationBody = styled.div`
  display: flex;
  flex-direction: column;
`;

Styled.BoxImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  min-width: 40px;
  height: 40px;
  min-height: 40px;
  margin: 0 16px 0 8px;
`;

Styled.NotificationAppIcon = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;

  width: ${(props) => {
    if (props.appId === 6) { return '35px'; }  // Evaluaciones
    if (props.appId === 9) { return '42.5px'; }  // Plan de Desarrollo
    if (props.appId === 11) { return '42.5px'; }  // Organigrama
    if (props.appId === 12) { return '37.5px'; }  // Auditoría
    if (props.appId === 18) { return '42.5px'; }  // Reclutamiento
    if (props.appId === 19) { return '37.5px'; }  // Expediente
    if (props.appId === 20) { return '42.5px'; }  // Buzón
    if (props.appId === 21) { return '35px'; }  // Centro de Ayuda
  }};

  height: ${(props) => {
    if (props.appId === 6) { return '35px'; }  // Evaluaciones
    if (props.appId === 9) { return '42.5px'; }  // Plan de Desarrollo
    if (props.appId === 11) { return '42.5px'; }  // Organigrama
    if (props.appId === 12) { return '37.5px'; }  // Auditoría
    if (props.appId === 18) { return '42.5px'; }  // Reclutamiento
    if (props.appId === 19) { return '37.5px'; }  // Expediente
    if (props.appId === 20) { return '42.5px'; }  // Buzón
    if (props.appId === 21) { return '35px'; }  // Centro de Ayuda
  }};
`;

Styled.NotificationMessage = styled(Typography.Text)`
  word-break: break-word;
  line-height: 1.3;
`;

Styled.AppText = styled(Typography.Text)`
  font-family: 'Bryant Pro Medium';
  font-size: ${(props) => props.theme.typography.smallText};
`;

Styled.TimeText = styled(Typography.Text)`
  margin-top: 2.5px;
  margin-left: 5px;
  font-family: 'Bryant Pro Medium';
  font-size: 10px;
`;

Styled.BoxTime = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1px;

  .MuiSvgIcon-root {
    font-size: 14px;
  }
`;

Styled.BoxClose = styled(MUI.ButtonIcon)`
  &.MuiButton-root {
    width: 22px;
    height: 22px;
    padding: 8px;
    margin: 0 0 0 8px;
  }

  .MuiSvgIcon-root {
    font-size: 14px;
  }
`;

export default Notification;
